const options = {
    builder: {
        data: false,
        premium: false,
        resource: false,
        stakeholderFields: {
            title: 'Stakeholder fields',
            default: false,
            weight: 0,
            components: {
                stakeholderFirstname: true,
                stakeholderLastname: true,
                stakeholderEmail: true,
                stakeholderMobile: true,
                stakeholderAddress: true,
                stakeholderOrganisation: true,
                stakeholderDistLists: true,
            },
        },
        basic: {
            title: 'Basic fields',
            default: false,
            weight: 1,
            components: {
                password: false,
                number: false,
                time: false,
                content: false,
                button: false,
                checkbox: false,
                selectboxes: false,
                select: false,
                textfield: true,
                textarea: true,
                customCheckbox: {
                    title: 'Single checkbox',
                    key: 'checkbox',
                    icon: 'fa fa-check-square',
                    schema: {
                      label: 'Checkbox',
                      type: 'checkbox',
                      key: 'checkbox',
                      input: true,
                    },
                },
                customSelectboxes: {
                    title: 'Checkboxes',
                    key: 'selectboxes',
                    icon: 'fa fa-plus-square',
                    schema: {
                      label: 'Checkboxes',
                      type: 'selectboxes',
                      key: 'selectboxes',
                      input: true,
                    },
                },
                radio: true,
                customSelect: {
                    title: 'Dropdown',
                    key: 'select',
                    icon: 'fa fa-th-list',
                    schema: {
                      label: 'Dropdown',
                      type: 'select',
                      key: 'select',
                    },
                },
                sentiment: true,
                categories: true,
            }
        },
        advanced: {
            title: 'Advanced fields',
            default: false,
            weight: 2,
            components: {
                day: false,
                tags: false,
                currency: false,
                resource: false,
                file: false,
                survey: false,
                htmlelement: false,
                sortlist: true,
                email: true,
                url: true,
                number: true,
                phonenumber: true,
                address: true,
                datetime: true,
                time: true,
                customHTML: {
                    title: 'HTML element',
                    key: 'htmlelement',
                    icon: 'fa fa-code',
                    schema: {
                      label: 'HTML element',
                      type: 'htmlelement',
                      key: 'htmlelement',
                    },
                },
                customFile: {
                    title: 'Upload file(s)',
                    key: 'file',
                    icon: 'fa fa-file',
                    schema: {
                      label: 'Upload file(s)',
                      type: 'file',
                      key: 'file',
                    },
                },
                customSurvey: {
                    title: 'Matrix survey',
                    key: 'survey',
                    icon: 'fa fa-list',
                    schema: {
                      label: 'Matrix survey',
                      type: 'survey',
                      key: 'survey',
                    },
                },
                signature: true,
            },
        },
        layout: {
            weight: 3,
            components: {
                htmlelement: false,
                content: false,
                fieldset: false,
                panel: false,
                table: false,
                tabs: false,
                customTabs: {
                    title: 'Form steps',
                    key: 'tabs',
                    icon: 'fa fa-square',
                    schema: {
                        label: 'Form steps',
                        type: 'tabs',
                        key: 'tabs',
                    },
                },
                well: false,
                columns: true,
                button: true,
            },
        },
    },
};

export default options;
